import { PopconfirmButton } from '@/components/_SiteWide/PopconfirmButton'
import { GraviButton, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Input, Popover } from 'antd'
import React, { useState } from 'react'

export function RequestActions({ data, rejectRequest, acceptRequest }) {
  return (
    <div className='flex justify-end'>
      {data.status.toLowerCase() !== 'rejected' && <RejectPopover rejectRequest={rejectRequest} id={data.id} />}
      {data.status === 'open' && (
        <PopconfirmButton
          buttonProps={{
            theme2: true,
            buttonText: 'Approve',
          }}
          onConfirm={() => acceptRequest(data.id)}
          popconfirmProps={{
            disabled: data.invoice_status !== 'sent',
            title: (
              <Vertical>
                <Texto weight='bold'>WARNING:</Texto>
                <Texto>
                  An invoice for this item has already been sent to the customer. Please contact the freight team to
                  resolve this issue. Would you like to continue?
                </Texto>
              </Vertical>
            ),
            okText: 'Yes',
            cancelText: 'No',
            placement: 'topRight',
          }}
        />
      )}
    </div>
  )
}

function RejectPopover({ rejectRequest, id }) {
  const [showingPopover, setShowingPopover] = useState()
  const [reason, setReason] = useState('')

  const hidePopover = () => {
    setShowingPopover(false)
  }

  const handleReasonChange = (e) => {
    setReason(e.target.value)
  }

  return (
    <Popover
      placement='left'
      content={
        <div>
          <Input onChange={handleReasonChange} />
          <div className='mt-3 special-pay-reject'>
            <GraviButton buttonText='Cancel' appearance='outline' onClick={hidePopover} />
            <GraviButton
              error
              appearance='outlined'
              buttonText='Reject'
              disabled={!reason || reason === '' || reason.length < 5}
              className='reject-special-pay ml-2'
              onClick={() => {
                hidePopover()
                rejectRequest(id, reason)
              }}
            />
          </div>
        </div>
      }
      title='Why do you want to reject this request?'
      trigger='click'
      visible={showingPopover}
    >
      <GraviButton
        error
        buttonText='Reject'
        className='mr-2'
        onClick={() => {
          setShowingPopover(true)
        }}
      />
    </Popover>
  )
}
